module.exports = __webpack_public_path__ + "Lato-BlackItalic.242ab22fe67d38c368c6.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-BlackItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato-BlackItalic.ttf
// module chunks = styles